<!--
* @Description:项目执行人数统计1
* @Date: 2024-01-18 16:33:01
-->
<template>
  <div
    class="survey"
    ref="TaskRef"
    :style="{
      transform: `scale(${scale})`,
      transformOrigin: '0 0'
    }"
  >
    <div class="content" ref="ContentRef">
      <div class="content-warp">
        <div
          v-for="(item, index) in _data"
          :key="index"
          class="content-warp-item"
        >
          <div class="content-warp-item-number">{{ item.data }}</div>
          <component
            :is="item.comp"
            :controlColor="`var(--theme-color-${index + 1},#000)`"
          ></component>
          <div
            :style="index + 1 == 2 ? 'width: 265px' : ''"
            class="content-warp-item-tip"
          >
            {{ item.tipsText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { OptionData } from './type';
import { surveySvg41 } from './svg-components/index';
import { selfAdaption, dataProcessing } from './hooks';
import { onMounted, ref } from 'vue';
const porps = defineProps<{ optionData: OptionData }>();
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
let comps = [surveySvg41, surveySvg41, surveySvg41];
let _data = dataProcessing(porps.optionData, comps);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
});
</script>

<style lang="scss" scoped>
@import './index.scss';
.survey {
  width: 1024px;
  height: 485px;
  display: grid;
  .content {
    margin: auto;
    width: 1024px;
    height: 485px;
    padding: 112px 88px 111px 88px;
    .content-warp {
      height: 262px;
      width: 848px;
      display: flex;
      justify-content: space-between;
      .content-warp-item {
        width: 199px;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        .content-warp-item-number {
          top: 130px;
          position: absolute;
          @include number();
          color: #fff;
        }
        .content-warp-item-tip {
          width: 100%;
          height: 28px;
          position: absolute;
          top: 280px;
          text-align: center;
          @include title();
        }
      }
    }
  }
}
</style>
